<template>
<div>
    <Breadcrumbs main="Admin" submain="Resources" title="Asset" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <router-link to="/resources/asset/create">
                            <button class="btn btn-primary" style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New Asset</h7>
                            </button>
                        </router-link>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="asset_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(name)="row">
                                        <div v-if="row.item.name">
                                            <p>{{ row.item.name }}</p>
                                        </div>
                                    </template>

                                    <template #cell(updated_at)="row">
                                        <div v-if="row.item.updated_at">
                                            <h7 v-if="row.item.updated_at">{{ formatDate(row.item.updated_at).date }} | {{ formatDate(row.item.updated_at).time }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(status)="row">
                                        <div v-if="row.item.status">
                                            <span v-if="row.item.status == 'APPROVAL PENDING'">
                                                <b-badge pill variant="info">{{ row.item.status }}</b-badge>
                                            </span>
                                            <span v-if="row.item.status == 'UNDER MAINTENANCE'">
                                                <b-badge pill variant="warning">{{ row.item.status }}</b-badge>
                                            </span>
                                            <span v-if="row.item.status == 'ACTIVE'">
                                                <b-badge pill variant="success">{{ row.item.status }}</b-badge>
                                            </span>
                                            <span v-if="row.item.status == 'INACTIVE'">
                                                <b-badge pill variant="danger">{{ row.item.status }}</b-badge>
                                            </span>
                                        </div>
                                    </template>

                                    <template #cell(location)="row">
                                        <div v-if="row.item.location_details">
                                            <p>{{ [row.item.location_details?.name, row.item.location_details?.camp?.camp_name, row.item.location_details?.area?.area_name, row.item.location_details?.district?.district_name, row.item.location_details?.country?.country_name].filter(Boolean).join(', ') }}</p>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <router-link :to="'/resources/asset/detail/' + data.item.ast_ID">
                                                <feather type="eye" size="20px" style="color: #2c323f; cursor: pointer;" v-b-tooltip.hover title="Details"></feather>
                                            </router-link>
                                            <router-link :to="'/resources/asset/edit/' + data.item.ast_ID">
                                                <feather type="edit" size="18px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit"></feather>
                                            </router-link>
                                            <div>
                                                <feather type="user-plus" size="18px" style="color: #e4701e; cursor: pointer;" v-b-tooltip.hover title="Assign User" v-b-modal.modal-assign-user @click="assignUser(data.item.id)"></feather>
                                            </div>
                                            <div>
                                                <feather type="delete" size="18px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteType(data.item.id)" title="Delete"></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Assign User Modal -->
    <b-modal id="modal-assign-user" ref="modal" title="Assign User" size="md" @show="resetAssignModal" @hidden="resetAssignModal" @ok="handleAssignOk">
        <form ref="form" @submit.stop.prevent="handleAssignSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Type</label>
                        <select class="form-control digits" v-model="user_assign.type_id" @change="getVolunteer(user_assign.type_id)">
                            <option selected disabled>Select a type</option>
                            <option v-for="(type, index) in volunteerTypes" :key="index" :value="type.name">{{ type.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>User</label>
                        <multiselect v-model="assignedUser" tag-placeholder="Add user" placeholder="Search or add a user" label="user_name" :max="users.length" track-by="id" :options="users" :multiple="true" :taggable="true"></multiselect>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Asset Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this asset?</div>
    </b-modal>
</div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';

export default {
    components: {
        loader,
        Multiselect,
        Datepicker
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Name',
                    sortable: false
                },
                {
                    key: 'ast_ID',
                    label: 'Asset ID',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'type.name',
                    label: 'Type',
                    sortable: true
                },
                {
                    key: 'location',
                    label: 'Location',
                    sortable: false
                },
                {
                    key: 'updated_at',
                    label: 'Updated At',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            assignedUser: [],
            user_assign: {
                user_id: [],
                asset_id: null,
                type_id: null
            },
            delete_value: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            pageOptions: [20, 50, 100]
        };
    },

    computed: {
        ...mapState({
            users: state => state.volunteer.volunteer,
            asset_list: state => state.asset.asset,
            volunteerTypes: state => state.volunteer.volunteerType,
            loading: state => state.asset.assetLoading,
            error: state => state.asset.assetError
        })
    },

    mounted() {
        this.$store.dispatch("volunteer/fetchVolunteer")
        this.$store.dispatch("volunteer/fetchType")
        this.$store.dispatch("asset/fetchAsset").then(() => {
            this.items = this.asset_list
            this.totalRows = this.asset_list.length;
        });
    },

    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        formatDate(dateStr) {
            if (!dateStr) return ''

            // Split date and time manually
            const [datePart, timePart] = dateStr.replace('Z', '').split('T')

            const [year, month, day] = datePart.split('-')
            const [hourRaw, minute] = timePart.split(':')

            const hours = parseInt(hourRaw)

            const monthNames = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ]

            const monthName = monthNames[parseInt(month) - 1]

            const ampm = hours >= 12 ? 'PM' : 'AM'
            const hour12 = hours % 12 || 12

            return {
                date: `${parseInt(day)} ${monthName}, ${year}`,
                time: `${hour12}:${minute} ${ampm}`
            }
        },

        getVolunteer(type_id) {
            this.$store.dispatch("volunteer/fetchVolunteerByType", type_id)
        },

        assignUser(id) {
            this.user_assign.asset_id = id
        },

        resetAssignModal() {
            this.assignedUser = [];
            this.user_assign.type_id = null;
            this.user_assign.user_id = null;
        },

        handleAssignOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleAssignSubmit()
        },

        handleAssignSubmit() {
            this.user_assign.user_id = this.assignedUser.map(item => item.id);
            this.$store.dispatch("asset/assignUsertoAsset", {
                user_id: this.user_assign.user_id,
                asset_id: this.user_assign.asset_id,
            }).then(response => {
                if (response.code == 201) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.assignedUser = [];
                    this.user_assign.asset_id = null
                    this.user_assign.type_id = null
                    this.user_assign.user_id = []
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-assign-user')
            })
        },

        deleteType(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("asset/deleteAsset", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 204) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
